import gql from "graphql-tag";

const BodyMapProps = gql`
	fragment BodyMapProps on BodyMap {
		id
		description
		injuryType
		photo
		created_at
	}
`;

const LIST = gql`
	query GetBodyMapOfPatient($patient: ID!) {
		GetPatientBodyMap(patient: $patient) {
			docs {
				...BodyMapProps
			}
		}
	}
	${BodyMapProps}
`;

const CREATE = gql`
	mutation NewBodyMap($model: BodyMapInput!) {
		NewBodyMap(model: $model) {
			message
			doc {
				...BodyMapProps
			}
		}
	}
	${BodyMapProps}
`;
export { LIST, CREATE };
